<template>
  <strong class="logo">
    <template v-if="getRouteName === 'index' || getRouteName === 'errorPage' ">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" class="logo__svg" fill="#444" viewBox="0 0 169 27.2">
          <path d="M.7 12.8C1.3 9.6 4 7.4 7.9 7.4c4.5 0 7.9 1.9 7.9 8v11.4H12l-.5-2.5c-1.3 1.7-3.1 2.8-5.8 2.8-3.2 0-5.7-2-5.7-5.8S3.3 15 8 15h3.1v-.9c0-2.1-1.6-2.8-3.3-2.8-1.3 0-2.7.4-3.3 2.2l-3.8-.7zm6.1 10.4c2.1 0 4.3-1.5 4.3-3.9v-.4h-3c-2-.1-3.2.7-3.2 2.4 0 .9.7 1.9 1.9 1.9zm84.3-10.4c.6-3.1 3.3-5.3 7.2-5.3 4.5 0 7.9 1.9 7.9 8v11.4h-3.8l-.5-2.5c-1.3 1.7-3.1 2.8-5.8 2.8-3.2 0-5.7-2-5.7-5.8s3.3-6.3 8-6.3h3.1v-.9c0-2.1-1.6-2.8-3.3-2.8-1.3 0-2.7.4-3.3 2.2l-3.8-.8zm6.1 10.4c2.1 0 4.3-1.5 4.3-3.9v-.4h-3.1c-2 0-3.2.7-3.2 2.5.1.8.8 1.8 2 1.8zm13.3-15.5h4.6v3.1c1.3-2.3 3.4-3.4 5.6-3.4.8 0 1.5.1 2.3.4l-.8 4.4c-.5-.4-1.1-.6-1.9-.6-2.7 0-5.1 2.3-5.1 8.5v6.8l-4.6.1-.1-19.3zm22.3-.3c1.9 0 3.7 1 4.6 2V0h4.6v26.9h-4.6v-2c-.5 1-2.2 2.3-4.6 2.3-5.7 0-8.6-4-8.6-9.9s3-9.9 8.6-9.9zm.7 15.8c2.4 0 4.3-2 4.3-5.8s-1.9-5.8-4.3-5.8-4.3 2-4.3 5.8 1.9 5.8 4.3 5.8zm25.4-12.7l-2.8 2.6c-.8-1.2-2.1-1.7-3.1-1.7-.9 0-1.8.6-1.8 1.6 0 .9.7 1.5 1.8 1.8 2.6 1 6.8 1.8 6.8 5.9 0 3.5-2.6 6.4-6.7 6.4-3.9 0-6.6-2.8-7.5-5.1l3.7-2c.7 1.8 1.9 3.2 3.8 3.2 1.4 0 2.4-.7 2.4-2.1 0-1.6-2.4-2-4.7-2.9-2.1-.9-3.8-2.2-3.8-5.1s2.4-5.6 6-5.6c2.5-.1 4.7 1.1 5.9 3zM62.2 7.7l-3.4 13.2-3.2-13.2h-4.3l-3.1 13.2-2.7-7.7-.3 1-1.5 4.9 2.4 7.8h4.1l3.3-12.4 3.2 12.4h4.1l6.1-19.2h-4.7zm22.4 0l-3.4 13.2L78 7.7h-4.3l-3.1 13.2-2.7-7.7-.3 1-1.5 4.9 2.4 7.8h4.1l3.3-12.4 3.2 12.4h4.1l6.1-19.2h-4.7zm-40.1 0l-6.1 19.2h-4.1l-3.2-12.4-3.3 12.4h-4.1l-6-19.1h4.7l3.4 13.1L29 7.8h4.3l3.2 13.1 3.3-13.1 4.7-.1zm121.4 13c1.8 0 3.1 1.3 3.1 3.2s-1.3 3.2-3.1 3.2-3.1-1.3-3.1-3.2 1.3-3.2 3.1-3.2z"/>
        </svg>
        <h4 class="logo__text">
          CONF
        </h4>

      </div>
    </template>

    <template v-else>
      <router-link to="/">
        <svg xmlns="http://www.w3.org/2000/svg" class="logo__svg logo__svg--small" fill="#444" viewBox="0 0 27.6 27.2">
          <path d="M22.4 11.4l-5 15.7H14L11.2 17 8.5 27.2H5L0 11.5h3.9l2.8 10.8 2.7-10.8H13l2.7 10.8 2.8-10.8 3.9-.1zM25 22c1.5 0 2.6 1.1 2.6 2.6s-1.1 2.6-2.6 2.6-2.6-1.1-2.6-2.6S23.5 22 25 22z"/>
        </svg>

        <h4 class="logo__text" data-hover="CONF">
          <span
            v-html="getCity === undefined ? '' : getCity === 'amsterdam' ? 'AMS' : getCity === 'new-york' ? 'NY' : 'SF'"
          ></span>
        </h4>
      </router-link>
    </template>
  </strong>
</template>

<script>
import { mapGetters } from 'vuex';


export default {
  name: 'Logo',

  computed: {
    ...mapGetters(['getCity', 'getRouteName']),
  },
};
</script>

<style lang="scss" scoped>
.logo {
  position: relative;

  > a,
  > div {
    display: inline-flex;
    justify-content: flex-start;
    align-items: baseline;
  }

  &__svg,
  &__text {
    display: inline-block;
  }

  &__svg {
    width: 135px;
    height: 22px;

    &.logo__svg--small {
      width: 28px;
      height: 27px;
    }
  }

  &__text {
    position: relative;
    width: 70px;
    margin-left: 10px;

    font-weight: normal;
    font-size: 23px; // font-size(m)

    overflow: hidden;

    span {
      display: inline-block;
      position: relative;

      transform: translateY(0);
      transition: transform 0.4s $global-ease,
        opacity 0.4s $global-ease 0.1s;
      opacity: 1;
    }

    &::before {
      content: attr(data-hover);

      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;

      opacity: 0;
      transform: translateY(100%);
      transition: transform 0.4s $global-ease,
        opacity 0.4s $global-ease 0.1s;
    }
  }

  @at-root .pointerevents:not(.touchevents) &:hover,
  .no-pointerevents.no-touchevents &:hover {
    .logo__text span {
      transform: translateY(-100%);
      opacity: 0;
    }

    .logo__text::before {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
